import { render, staticRenderFns } from "./SetariVanzari.vue?vue&type=template&id=694c1d04&scoped=true"
import script from "./SetariVanzari.vue?vue&type=script&lang=js"
export * from "./SetariVanzari.vue?vue&type=script&lang=js"
import style0 from "./SetariVanzari.vue?vue&type=style&index=0&id=694c1d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694c1d04",
  null
  
)

export default component.exports